/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import React from 'react';

import { connect } from 'react-redux';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import { footerLinks } from 'services/Externals';
import TRP from 'components/shared/TRP/TRP';
import { ReactComponent as StopTransferImage } from 'assets/StopTransferImage.svg';
import { bool } from 'prop-types';
import { showStopTransferZeroState } from 'state/linkedBankAccounts/LinkedBankAccountsSelectors';

const StopTransferZeroState = ({ showStopTransferZeroState }) =>
  showStopTransferZeroState ? (
    <PreferencesSection className="zero-state-card" fullBackground>
      <StopTransferImage />
      <p className="zero-state-card-copy">
        There is a &quot;<b>Stop Transfer</b>&quot; on your <TRP /> account.{' '}
        <a
          className="contact-us-link"
          href={footerLinks.contactUsUrl}
          rel="noopener noreferrer"
          target="_blank">
          Contact us
        </a>{' '}
        for more information and to link a new bank account.
      </p>
    </PreferencesSection>
  ) : null;

StopTransferZeroState.propTypes = {
  showStopTransferZeroState: bool
};

StopTransferZeroState.defaultProps = {
  showStopTransferZeroState: false
};

const mapStateToProps = (state) => ({
  showStopTransferZeroState: showStopTransferZeroState(state)
});

export default connect(mapStateToProps)(StopTransferZeroState);
